import React, { useState, useEffect } from "react";
import "../../components/AddOpsExpense/AddOpsExpense.css";
import axios from "axios";
import { useLocation } from "react-router-dom";
import MiniDrawer from "../MiniDrawer/MiniDrawer";
import { useRef } from "react";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CryptoJS from "crypto-js";
import Wrapper from "../../components/UI/Wrapper";

const AddOpsExpense = () => {
  const [formData, setFormData] = useState(null);
  const [fieldOpsResponse, setFieldOpsResponse] = useState(null);
  const [updatedFormData, setUpdatedFormData] = useState({
    Amount: null,
    Relocation_Id: "",
    Description: "",
    Expense_Type: "",
    Job_Id: null,
    Document: "",
    Created_By: "",
  });
  const [expense_Type, setExpense_Type] = useState(null);
  const [relocationIdPresent, setRelocationIdPresent] = useState(false);
  const baseAPI = process.env.REACT_APP_API_URL;
  const fileInputRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const relocationId = queryParams.get("Relocation_Id");
    if (relocationId !== null) {
      decryptRelocationID(relocationId);
      setRelocationIdPresent(true);
      getExpenseTypeList();
    } else {
      getFieldOpsList();
    }
  }, []);

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      getSelectedRelocationIdDetail(
        parseInt(bytes.toString(CryptoJS.enc.Utf8))
      );

      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      // setDecryptionError(true);

      return null;
    }
  }

  function getFieldOpsList() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}UserGet/GetFieldOpsDetail?RelocationId=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setFieldOpsResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      try {
        const response = await axios.post(
          `${baseAPI}Userpost/AddFieldOpsExpense?ExpenseId=0`,
          updatedFormData,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        alert("Expense successfully added");
        setUpdatedFormData({
          ...updatedFormData,
          Amount: "",
          Description: "",
          Expense_Type: "",
          Document: "",
          Job_Id: "",
        });
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } catch (error) {
        console.error("Error posting data:", error);
      }
    }
  };

  const handleChange = (type, e) => {
    const { name, value, files } = e.target;
    if (type === "get") {
      getSelectedRelocationIdDetail(parseInt(value));
      getExpenseTypeList();
    } else {
      if (name === "Document") {
        const file = files[0];
        getUpdatedDocument(file, name);
      } else {
        setUpdatedFormData({
          ...updatedFormData,
          [name]: value,
        });
      }
    }
  };

  function getUpdatedDocument(file, name) {
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const imageData = reader.result;
        setUpdatedFormData({
          ...updatedFormData,
          [name]: imageData,
        });
      };

      reader.readAsDataURL(file);
    }
  }

  function getSelectedRelocationIdDetail(id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}UserGet/GetFieldOpsDetail?RelocationId=${id}`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setFormData(response.data.data[0]);
          setUpdatedFormData({
            ...updatedFormData,
            Relocation_Id: response.data.data[0].Relocation_ID,
          });
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  function getExpenseTypeList() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}UserGet/GetFieldOpsExpenseTypeList`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setExpense_Type(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  function handleReset() {
    setUpdatedFormData({
      ...updatedFormData,
      Amount: "",
      Description: "",
      Expense_Type: "",
      Document: "",
      Job_Id: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }

  return (
    <div className="d-flex flex-row app" style={{ backgroundColor: "#F4F4F4" }}>
      <MiniDrawer />
      <div className="container-fluid responsiveExpense" style={{ backgroundColor: "#F4F4F4" }}>
        <div style={{ marginTop: "90px"  }}>
          <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
            Expense| <HomeOutlinedIcon />{" "}
            <span style={{ fontSize: "20px" }}>&gt; Operations</span>{" "}
                <a
                  style={{ color: "black", textDecoration: "none" }}
                  href="/ExpenseList"
                >
              <span style={{ fontSize: "20px" }}>&gt; Expense</span>
                </a>
            <span style={{ fontSize: "20px" }}>&gt; Add Expense</span>
              </h1>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <div>
                  <form
                    style={{ paddingTop: "30px", paddingLeft: "20px" }}
                    className="country-form"
                  >
                    {fieldOpsResponse !== null ? (
                      <>
                <table style={{ marginTop: "-25px", width: "100%" }}>
                          <tbody>
                            <tr
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "50%",
                              }}
                              className="tableHeading"
                            >
                      <td
                        style={{
                          color: "#6a6a6a",
                          fontWeight: "bold",
                          width: "100%",
                          marginTop: "13px",
                        }}
                      >
                                Select Your Relocation ID
                              </td>
                      <td className="selectOptionExpense"
                       
                              >
                                <select
                                  style={{
                                    border: "1px solid #5b489d",
                                    width: "100%",
                                    marginTop: "-10px",
                                    padding: "12px",
                                    borderRadius: "6px",
                                    marginBottom: "21px",
                                    height: "45px",
                                    color: "#6a6a6a",
                                    position: "relative",
                                    marginLeft: "0px",
                                  }}
                                  className="form-control"
                                  name="RelocationId"
                          onChange={(event) => handleChange("get", event)}
                                  required
                                >
                                  <option value="0">Select an option</option>
                                  {fieldOpsResponse !== null
                                    ? fieldOpsResponse.map((item) => (
                                        <option
                                          key={item.Relocation_ID}
                                          value={item.Relocation_ID}
                                        >
                                          {item.Relocation_ID}
                                        </option>
                                      ))
                                    : null}
                                </select>
                              </td>
                            </tr>
                            <tr className="space">
                              <td colSpan={3}></td>
                            </tr>
                          </tbody>
                        </table>
                        <br />
                        <hr />
                      </>
                    ) : null}
                    {formData !== null ? (
                      <>
                        <div style={{ marginTop: "20px", display: "flex", border: "1px solid #DEE2E6" }}>
                          <table className="leadlist_1">
                            <tr className="viewLeadDetailsHeading expenseHeading">
                              <th>
                                <span>First Name</span>
                              </th>
                              <td style={{ borderBlock: "1px solid #ccc" }}>
                                <span>{formData.First_Name}</span>
                              </td>
                              <th>
                                <span>Last Name</span>
                              </th>
                              <td style={{ borderBlock: "1px solid #ccc" }}>
                                <span>{formData.Last_Name}</span>
                              </td>
                            </tr>
                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Contact Number</span>
                              </th>
                              <td>
                                <span>{formData.Mobile_No}</span>
                              </td>
                              <th>
                                <span>Relocation ID</span>
                              </th>
                              <td>
                                <span>{formData.Relocation_ID}</span>
                              </td>
                            </tr>
                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Pet Type</span>
                              </th>
                              <td>
                                <span>{formData.PetType}</span>
                              </td>
                              <th>
                                <span>Pet Breed</span>
                              </th>
                              <td>
                                <span>{formData.PetBreedType}</span>
                              </td>
                            </tr>
                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Origin Country</span>
                              </th>
                              <td>
                                <span>{formData.Origin_Country_Name}</span>
                              </td>
                              <th>
                                <span> Destination Country</span>
                              </th>
                              <td>
                                <span>{formData.Destination_Country_Name}</span>
                              </td>
                            </tr>
                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Origin State</span>
                              </th>
                              <td>
                                <span>{formData.Origin_State_Name}</span>
                              </td>
                              <th>
                                <span>Destination State</span>
                              </th>
                              <td>
                                <span>{formData.Destination_State_Name}</span>
                              </td>
                            </tr>
                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Origin City</span>
                              </th>
                              <td>
                                <span>{formData.Origin_City_Name}</span>
                              </td>
                              <th>
                                <span>Destination City</span>
                              </th>
                              <td>
                                <span>{formData.Destination_City_Name}</span>
                              </td>
                            </tr>
                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Assigned To</span>
                              </th>
                              <td>
                                <span style={{width:"2rem"}}>{formData.Assigned_To}</span>
                              </td>
                              <th></th>
                              <td></td>
                            </tr>
                          </table>
                        </div>
                        <br />
                        <hr />
                        <div style={{ MarginTop: "20px" }}>
                          <h2
                            className="Venderheading"
                            style={{
                              fontSize: "22px",
                              paddingLeft: "16px",
                              paddingTop: "7px",
                            }}
                          >
                            Add Expense
                          </h2>
                          <table
                            style={{ width: "100%", marginBottom: "70px" }}
                            className="addvendorTable"
                          >
                            <tr
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                              className="tableHeading tableHeading2"
                            >
                              <td
                                style={{
                                  color: "#6a6a6a",
                                  fontWeight: "bold",
                                  width: "100%",
                                  marginTop: "13px",
                                }}
                              >
                                Amount
                              </td>
                              <td
                                style={{
                                  color: "#6a6a6a",
                                  fontWeight: "bold",
                                  width: "100%",
                                  marginTop: "13px",
                                }}
                              >
                                Description
                              </td>
                            </tr>
                            <tr
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                              className="tableHeading tableHeading2"
                            >
                              <td
                                style={{
                                  color: "#6a6a6a",
                                  fontWeight: "bold",
                                  width: "100%",
                                  marginTop: "13px",
                                }}
                              >
                                <input
                                  type="number"
                                  style={{
                                    border: "1px solid #5b489d",
                                    width: "100%",
                                    padding: "12px",
                                    borderRadius: "6px",
                                    marginBottom: "21px",
                                    marginTop: "25px",
                                    height: "45px",
                                    color: "#6a6a6a",
                                    position: "relative",
                                  }}
                                  name="Amount"
                          onChange={(event) => handleChange("insert", event)}
                                  value={updatedFormData.Amount}
                                  placeholder="Please Enter*"
                                  required
                                />
                              </td>
                              <td
                                style={{
                                  color: "#6a6a6a",
                                  fontWeight: "bold",
                                  width: "100%",
                                  marginTop: "13px",
                                }}
                              >
                                <input
                                  type="text"
                                  style={{
                                    border: "1px solid #5b489d",
                                    width: "100%",
                                    padding: "12px",
                                    borderRadius: "6px",
                                    marginBottom: "21px",
                                    marginTop: "25px",
                                    height: "45px",
                                    color: "#6a6a6a",
                                    position: "relative",
                                  }}
                                  name="Description"
                          onChange={(event) => handleChange("insert", event)}
                                  value={updatedFormData.Description}
                                  placeholder="Please Enter*"
                                  required
                                />
                              </td>
                            </tr>
                            <tr
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                marginTop: "76px",
                              }}
                              className="tableHeading tableHeading2"
                            >
                              <td
                                style={{
                                  color: "#6a6a6a",
                                  fontWeight: "bold",
                                  width: "100%",
                                  marginTop: "13px",
                                }}
                              >
                                Expense Type
                              </td>
                              <td
                                style={{
                                  color: "#6a6a6a",
                                  fontWeight: "bold",
                                  width: "100%",
                                  marginTop: "13px",
                                }}
                              >
                                Job Id
                              </td>
                            </tr>
                            <tr
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                              className="tableHeading tableHeading2"
                            >
                              <td
                                style={{
                                  color: "#6a6a6a",
                                  fontWeight: "bold",
                                  width: "100%",
                                  marginTop: "13px",
                                }}
                              >
                                <select
                                  style={{
                                    border: "1px solid #5b489d",
                                    width: "100%",
                                    padding: "12px",
                                    borderRadius: "6px",
                                    marginBottom: "21px",
                                    marginTop: "25px",
                                    height: "45px",
                                    color: "#6a6a6a",
                                    position: "relative",
                                    marginLeft: "0px",
                                  }}
                                  className="form-control"
                                  name="Expense_Type"
                          onChange={(event) => handleChange("insert", event)}
                                  required
                                  value={updatedFormData.Expense_Type}
                                >
                                  <option value="0">Select an option</option>
                                  {expense_Type !== null
                                    ? expense_Type.map((item) => (
                                <option key={item.Tseed} value={item.Tseed}>
                                          {item.TYPE}
                                        </option>
                                      ))
                                    : null}
                                </select>
                              </td>
                              <td
                                style={{
                                  color: "#6a6a6a",
                                  fontWeight: "bold",
                                  width: "100%",
                                  marginTop: "13px",
                                }}
                              >
                                {" "}
                                <input
                                  type="text"
                                  style={{
                                    border: "1px solid #5b489d",
                                    width: "100%",
                                    padding: "12px",
                                    borderRadius: "6px",
                                    marginBottom: "21px",
                                    marginTop: "25px",
                                    height: "45px",
                                    color: "#6a6a6a",
                                    position: "relative",
                                  }}
                                  name="Job_Id"
                          onChange={(event) => handleChange("insert", event)}
                                  value={updatedFormData.Job_Id}
                                  placeholder="Please Enter*"
                                  required
                                />
                              </td>
                            </tr>
                            <tr
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                marginTop: "76px",
                              }}
                              className="tableHeading tableHeading2"
                            >
                              <td
                                style={{
                                  color: "#6a6a6a",
                                  fontWeight: "bold",
                                  width: "100%",
                                  marginTop: "13px",
                                }}
                              >
                                Document
                              </td>
                            </tr>
                            <tr
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "50%",
                              }}
                              className="tableHeading tableHeading2"
                            >
                              <td
                                style={{
                                  color: "#6a6a6a",
                                  fontWeight: "bold",
                                  width: "100%",
                                  marginTop: "13px",
                                }}
                              >
                                {" "}
                                <input
                                  type="file"
                                  style={{
                                    border: "1px solid #5b489d",
                                    width: "100%",
                                    padding: "7px",
                                    borderRadius: "6px",
                                    marginBottom: "21px",
                                    marginTop: "25px",
                                    height: "45px",
                                    color: "#6a6a6a",
                                    position: "relative",
                                  }}
                                  name="Document"
                                  ref={fileInputRef}
                          onChange={(event) => handleChange("insert", event)}
                                  placeholder="Please Enter*"
                                  required
                                />
                              </td>
                            </tr>
                          </table>
                        </div>

                        <div className="reset-addCountry-button">
                          <button
                            onClick={handleSubmit}
                            type="submit"
                            style={{
                              marginRight: "4px",
                              backgroundColor: "#5B489D",
                              color: "white",
                            }}
                          >
                            Add Expense
                          </button>
                          <button
                            onClick={handleReset}
                    style={{ backgroundColor: "#F15843", color: "white" }}
                          >
                            Reset
                          </button>
                        </div>
                      </>
                    ) : null}
                  </form>
                </div>
              </Wrapper>
            </div>
          </div>
        </div>
      

  );
};

export default AddOpsExpense;
